//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCard from '~/components/Dashboard/Cards/BaseCard.vue'
import InfoCard from '~/components/Dashboard/Cards/InfoCard.vue'
import ActionCard from '~/components/Dashboard/Cards/ActionCard.vue'
import ImageCard from '~/components/Dashboard/Cards/ImageCard.vue'
import TagStatus from '~/components/Shared/TagStatus.vue'
import PROJECT_VALIDATION_STATUS from '~/constants/project-validation-status'

export default {
  components: {
    BaseCard,
    InfoCard,
    ActionCard,
    ImageCard,
    TagStatus,
  },
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      mapStatus: {
        [PROJECT_VALIDATION_STATUS.PENDING]: 'in-pending',
        [PROJECT_VALIDATION_STATUS.IN_PROGRESS]: 'in-progress',
        [PROJECT_VALIDATION_STATUS.FINISHED]: 'in-complete',
      },
    }
  },
  computed: {
    actionLabel() {
      return !this.project.status ||
        this.project.status === PROJECT_VALIDATION_STATUS.PENDING
        ? 'Comenzar'
        : 'Continuar'
    },
    status() {
      return this.mapStatus[this.project.status] || 'in-pending'
    },
    isActiveAction() {
      return this.project.status !== PROJECT_VALIDATION_STATUS.FINISHED
    },
  },
  methods: {
    handleClick() {
      this.$router.push(`/validation/${this.project.code}`)
    },
  },
}
